/* eslint-disable react/require-default-props,react/destructuring-assignment,react/button-has-type */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { autobind } from 'core-decorators';
import omit from 'lodash/omit';

import Comment from './index';
import styles from './index.styl';

@CSSModules(styles, { allowMultiple: true })
export default class Replies extends PureComponent {
  static propTypes = {
    commentAuthor: PropTypes.string,
    list: PropTypes.array, // todo,
    getCommentDeleteHandler: PropTypes.func,
    getCommentEditHandler: PropTypes.func,
    parentId: PropTypes.number,
    onRequestConversation: PropTypes.func,
    canComment: PropTypes.bool,
    loggedUserId: PropTypes.number,
  };

  state = {
    collapsed: null,
  };

  componentWillMount() {
    this.setState({
      collapsed: this.props.list.length > 2,
    });
  }

  @autobind
  handleExpand(e) {
    e.preventDefault();
    this.setState({ collapsed: false });
  }

  render() {
    const {
      commentAuthor,
      list,
      getCommentDeleteHandler,
      getCommentEditHandler,
      parentId,
      onRequestConversation,
      canComment,
      loggedUserId,
    } = this.props;
    const { collapsed } = this.state;
    const visibleList = collapsed ? list.slice(-2) : list;

    return (
      <div>
        <If condition={collapsed}>
          <button styleName="previousLink" onClick={this.handleExpand}>
            Show previous
          </button>
        </If>
        <ul styleName="replies">
          {visibleList &&
            visibleList.map(reply => (
              <li key={reply.id}>
                <Comment
                  {...omit(reply, ['comments'])}
                  getCommentDeleteHandler={getCommentDeleteHandler}
                  getCommentEditHandler={getCommentEditHandler}
                  parentId={parentId}
                  replyTo={commentAuthor}
                  onRequestConversation={onRequestConversation}
                  canComment={canComment}
                  loggedUserId={loggedUserId}
                />
              </li>
            ))}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Comment/Replies.jsx